// extracted by mini-css-extract-plugin
export var inlineLink = "_94-0";
export var inlineLinkButton = "_94-1";